import { render, staticRenderFns } from "./BodyBlog.vue?vue&type=template&id=689c50e2"
import script from "./BodyBlog.vue?vue&type=script&lang=js"
export * from "./BodyBlog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports